import { groupBy } from "lodash-es";

import User from "@mapmycustomers/shared/types/User";

import PlayheadTrack from "@app/store/mapLayers/userLocations/playback/types/PlayheadTrack";
import UserLocation from "@app/store/mapLayers/userLocations/types/UserLocation";

interface EventWithCreatedAtMs {
  createdAtMs: number;
  event: UserLocation;
}

// Build one ordered playback track per rep. Pure so the selector can memoize it and unit tests can
// drive it directly. Points are sorted ascending by time; the per-point `day` lets the interpolator
// detect undrawn cross-day gaps. Reuses already-parsed createdAtMs (never calls parseApiDate).
const buildPlayheadTracks = (eventsWithCreatedAtMs: EventWithCreatedAtMs[]): PlayheadTrack[] => {
  const byUserId = groupBy(eventsWithCreatedAtMs, (entry) => entry.event.userId);
  return Object.entries(byUserId).map(([userId, entries]) => ({
    points: [...entries]
      .sort((left, right) => left.createdAtMs - right.createdAtMs)
      .map((entry) => ({
        coordinates: [entry.event.geoPoint.coordinates[0], entry.event.geoPoint.coordinates[1]] as [
          number,
          number,
        ],
        day: entry.event.createdAtIsoDate,
        timeMs: entry.createdAtMs,
      })),
    userId: Number(userId) as User["id"],
  }));
};

export default buildPlayheadTracks;
